module.exports = __webpack_public_path__ + "ps.svg?b20ddc99ce78f3e6d0a175101690dbee";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ps.svg
// module id = 1109
// module chunks = 27